/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';
import Qs from "qs";

export default {
	lock(params = {}) {
		return Ajax.post('/lock', Qs.stringify(params));
	},
	login(params = {}) {
		return Ajax.post('/login', Qs.stringify(params));
	},
	register(params = {}) {
		return Ajax.post('/register', Qs.stringify(params));
	},
	mobilelogin(params = {}) {
		return Ajax.post('/mobileLogin', Qs.stringify(params));
	},
	mobileLoginMsg(mobile) {
		return Ajax.get(`/mobileLoginMsg/${mobile}`);
	},
	logout() {
		return Ajax.get('/logout');
	},
	init() {
		return Ajax.get('/init');
	},
	pdfFont(extendParam) {
		return Ajax.get('/pdf/font', null, Object.assign(extendParam, {
			responseType: 'blob'
		}));
	},
	updateUser(params = {}) {
		return Ajax.post('/updateUser', Qs.stringify(params));
	},
	updatePwd(params = {}) {
		return Ajax.post('/updatePwd', Qs.stringify(params));
	},
	changePhoneNumber(params = {}) {
		return Ajax.post('/changePhoneNumber', Qs.stringify(params));
	},
	sendMsg(mobile) {
		return Ajax.get(`/sendMsg/${mobile}`);
	},
	regMsg(mobile) {
		return Ajax.get(`/regMsg/${mobile}`);
	},
	renewalValid(code) {
		return Ajax.get(`/renewal/valid`, {code});
	},
	changeAccountSets(accountSetsId) {
		return Ajax.get(`/changeAccountSets?accountSetsId=${accountSetsId}`);
	},
	resetPassword(params = {}) {
		return Ajax.post('/resetPassword', Qs.stringify(params));
	},
	upload(type, formData, isTemp = false) {
		return Ajax.post(`/upload/${type}?isTemp=${isTemp}`, formData, {
			'Content-Type': 'multipart/form-data', 
			repeatable: true
		});
	},
	// 删除附件（物理删除）//AAASSS
	deleteAttachment(filePath) {
		return Ajax.delete(`/upload/attachment?path=${encodeURIComponent(filePath)}`);
	},
	// 新增：临时附件转正
	confirmUpload(tempPath) {
		return Ajax.post('/upload/confirm', Qs.stringify({ tempPath }));
	},

	// 获取存储信息//AAASSS
	getStorageInfo() {
		return Ajax.get('/upload/storage-info');
	}
}
